<template>
  <div>
    <form @submit.prevent="confirmRecharge">
      <div class="md-layout">
        <div class="md-layout-item md-gutter">
          <md-field>
            <label>Số tiền nạp</label>
            <md-input
              v-model="amount"
              :oninput="(amount = formatNumber(amount))"
              pattern="^[0-9].*$"
              title="Trường chỉ cho phép nhập số"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-field>
            <label>Ghi chú</label>
            <md-input v-model="note" md-autogrow></md-input>
          </md-field>
        </div>
      </div>
      <div class="formActions">
        <md-button
          class="md-success md-size-10"
          type="submit"
          :disabled="flagLoading"
        >
          <i class="fas fa-check"></i>
          Hoàn tất
        </md-button>
      </div>
    </form>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import EventBus from "../../EventBus.js";
import { mapGetters } from "vuex";
export default {
  props: ["user", "functions"],
  data() {
    return {
      amount: 0,
      isDeposit: true,
      note: `Nạp tiền vào tài khoản ${this.user.data.employeeCode}`,
    };
  },
  computed: {
    ...mapGetters(["flagLoading"]),
  },
  methods: {
    recharge() {
      let bits = localStorage.getItem("bits");
      this.$store.dispatch("FLAG_LOADING", true);
      var recharge = this.functions.httpsCallable(
        process.env.VUE_APP_CHANGE_DEPOSIT_FUNC + bits
      );
      recharge({
        amount: parseFloat(this.amount.replace(/\./g, "")),
        isDeposit: this.isDeposit,
        employeeCode: this.user.data.employeeCode,
        note: this.note,
      }).then((result) => {
        if (result.data.success === true) {
          this.$messageSuccess("Nạp tiền thành công");
          this.$store.dispatch("FLAG_LOADING", false);
          this.$emit("recharge", parseFloat(this.amount.replace(/\./g, "")));
          EventBus.$emit("reloadHistory");
        } else {
          this.$messageError("Nạp tiền không thành công");
          this.$store.dispatch("FLAG_LOADING", false);
        }
      });
      this.amount = 0;
      this.note = "";
    },
    confirmRecharge() {
      Swal.fire({
        title: "Xác nhận",
        text: `Nạp tiền vào tài khoản: ${this.user.data.name}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.recharge();
        }
      });
    },
  },
};
</script>
<style lang="css" scoped>
</style>
